import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
});

let _token = null;
export const setAuthToken = (t) => {
    _token = t;
    if (t) {
        api.defaults.headers.common["Authorization"] = `Bearer ${t}`;
        localStorage.setItem("acc_token", t);
    } else {
        delete api.defaults.headers.common["Authorization"];
        localStorage.removeItem("acc_token");
    }
};

export const getAuthToken = () => _token || localStorage.getItem("acc_token");

// Re-hydrate on module load
const stored = localStorage.getItem("acc_token");
if (stored) {
    _token = stored;
    api.defaults.headers.common["Authorization"] = `Bearer ${stored}`;
}

export const fmtMoney = (n, opts = {}) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    const sign = n < 0 ? "-" : "";
    const abs = Math.abs(n);
    return (
        sign +
        "$" +
        abs.toLocaleString("en-AU", {
            minimumFractionDigits: opts.decimals ?? 0,
            maximumFractionDigits: opts.decimals ?? 0,
        })
    );
};

export const fmtPct = (n) => {
    if (n === null || n === undefined || isNaN(n)) return "—";
    const sign = n > 0 ? "+" : "";
    return `${sign}${n.toFixed(1)}%`;
};

export const fmtDate = (s) => {
    if (!s) return "—";
    try {
        const d = new Date(s);
        return d.toLocaleDateString("en-AU", {
            day: "2-digit",
            month: "short",
            year: "numeric",
        });
    } catch {
        return s;
    }
};

export const fmtDateTime = (s) => {
    if (!s) return "—";
    try {
        const d = new Date(s);
        return d.toLocaleString("en-AU", {
            day: "2-digit",
            month: "short",
            hour: "2-digit",
            minute: "2-digit",
        });
    } catch {
        return s;
    }
};

export const shortId = (s) => (s ? s.split("-")[0] : "—");
